// extracted by mini-css-extract-plugin
export var closeButton = "_cn-1";
export var closeX = "_cn-3";
export var container = "_cn-0";
export var image = "_cn-2";